import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogHeader,
} from "../../../Components/ui/PersonalInfoPopUpDialog";
import { Button } from "../../../Components/ui/button";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { Input } from "../../../Components/ui/input";
import { useToast } from "../../../Components/ui/use-toast";
import { Toaster } from "../../../Components/ui/toaster";

interface UpdateBalanceProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    accountId: number;
    accountEmail: string;
}

const UpdateBalancePopUp: React.FC<UpdateBalanceProps> = ({
    isOpen,
    onOpenChange,
    accountEmail,
    accountId,
}) => {
    const apiUrlAdminAcc = useSelector(
        (state: RootState) => state.authentication.adminUrl
    );
    // const accountId = useSelector(
    //     (state: RootState) => state.authentication.account_id
    // );

    const CurrentAID = useSelector(
          (state: RootState) => state.authentication.account_id
        );
    
        const workspaceId = useSelector(
          (state: RootState) => state.authentication.workspace_id
        );

    const [isLoading, setIsLoading] = useState(false);
    const { toast } = useToast();


    const [displayPlanMessage, setDisplayPlanMessage] = useState<string>("");
    const [addMessageCount, setAddMessageCount] = useState<string>("");
    const [addMessageCountError, setAddMessageCountError] = useState<string | null>("");


    useEffect(() => {
        if (isOpen) {
            setIsLoading(true);
            axios
                .get(`${apiUrlAdminAcc}/GetAvailableMessagesByEmail`, {
                    params: { email: accountEmail },
                })
                .then((response) => {
                    if (response.data.status === "Success") {
                        setDisplayPlanMessage(response.data.availableMessages);
                        setIsLoading(false);
                    } else {
                        // Handle failure response
                        setDisplayPlanMessage("0");
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching wallet data:", error);
                    setIsLoading(false);
                });
        }
    }, [isOpen, accountEmail, apiUrlAdminAcc]);

    // const handlePlanMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     let value = e.target.value; // Remove existing commas
    //     if (value) {
    //         setDisplayPlanMessage(Number(value).toLocaleString()); // Display updated available messages
    //     } else {
    //         console.log("Error: Invalid input");
    //     }
    // };


    const handlePlanMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value.replace(/,/g, ""); // remove commas just in case
        if (!isNaN(Number(value))) {
            setDisplayPlanMessage(value);
        }
    };


    const handleDialogChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onOpenChange(event.target.checked);
    };


    const validateMessageCount = (value: string | number): boolean => {
        const num = Number(value);

        if (value === "" || value === null) {
            setAddMessageCountError("Message count is required");
            return false;
        }

        if (isNaN(num)) {
            setAddMessageCountError("Invalid number");
            return false;
        }

        if (!Number.isInteger(num)) {
            setAddMessageCountError("Message count must be a whole number");
            return false;
        }

        if (num <= 0) {
            setAddMessageCountError("Message count must be greater than 0");
            return false;
        }

        // ✅ Valid
        setAddMessageCountError(null);
        return true;
    };




    const handleAddClick = () => {
        // Prepare request params


        const isMessageCountValid = validateMessageCount(addMessageCount);
        if (!isMessageCountValid) {
            toast({
                title: "Error",
                description: "Validation Failed",
            });
            return;
        }


        const email = accountEmail;
        const messageCount = parseInt(addMessageCount);

        axios
            .post(
                `${apiUrlAdminAcc}/UpdateMessageCreditsByEmail?email=${encodeURIComponent(email)}&messageCount=${messageCount}&accountId=${accountId}&currentAID=${CurrentAID}&workspaceId=${workspaceId}`
            )
            .then((response) => {
                onOpenChange(false);
                if (response.data?.status === "Success") {
                    toast({
                        title: "Success",
                        description: "Wallet updated successfully!"
                    });
                    setAddMessageCount("");
                } else {
                    toast({
                        title: "Failure",
                        description: "Failed to update wallet"
                    });
                }
            })
            .catch((error) => {
                console.error("Error updating wallet:", error);
                toast({
                    title: "Error",
                    description: "An error occurred while updating the wallet"
                });
            });
    };

    useEffect(() => {
        if (!isOpen) {
            setDisplayPlanMessage("");
            setAddMessageCountError("");
            setAddMessageCount("");
            setTimeout(() => {
                document.body.style.pointerEvents = "";
            }, 500);
        }
        return;
    }, [isOpen]);

    return (
        <Dialog open={isOpen} onOpenChange={(isOpen) => onOpenChange(isOpen)}>
            <DialogContent className="w-full max-w-xl max-h-screen">
                <DialogHeader className="flex items-center mt-2">
                    <DialogTitle>Update Wallet Balance</DialogTitle>
                </DialogHeader>
                <div className="flex flex-col flex-grow gap-2">
                    <div className="ml-4 flex flex-col flex-grow gap-4 m-2">
                        <div className="flex flex-row flex-grow w-auto">
                            <div className="basis-1/3 text-[14px] shrink-0 font-medium text-[#020617]">
                                Account Email
                            </div>
                            <div className="basis-2/3 text-[14px] flex-grow font-normal break-all">
                                : {accountEmail}
                            </div>
                        </div>
                        <div className="flex flex-row">
                            <div className="flex basis-1/3 text-[14px] items-center font-medium text-[#020617]">
                                Avilable Messages
                            </div>
                            <div className="flex justify-center items-center">:</div>
                            <div className="basis-2/3 text-[14px] font-normal rounded-[7px] ml-1">
                                <Input
                                    id="planMessage"
                                    type="text"
                                    placeholder={isLoading ? "Loading..." : displayPlanMessage}
                                    value={displayPlanMessage}
                                    onChange={handlePlanMessageChange}
                                    className="mt-2 text-[#020617]"
                                    disabled
                                />
                            </div>

                        </div>
                        <div className="flex flex-row">
                            <div className="flex basis-1/3 text-[14px] items-center font-medium text-[#020617]">
                                Add Messages
                            </div>
                            <div className="flex justify-center items-center">:</div>
                            <div className="basis-2/3 text-[14px] font-normal rounded-[7px] ml-1">
                                <Input
                                    id="Add Messages"
                                    type="number"
                                    placeholder="Add Messages"
                                    className="mt-2 text-[#020617] "
                                    value={addMessageCount}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        validateMessageCount(val);
                                        setAddMessageCount(val);
                                    }}
                                    min={1}
                                />

                                {addMessageCountError && (
                                    <p className="text-red-500 text-xs font-medium  font-sans italic ml-1 text-left">
                                        {addMessageCountError}
                                    </p>
                                )}
                            </div>


                        </div>

                    </div>


                    <div className="flex justify-center flex-row gap-2">
                        <Button className="mb-2 py-1 w-full bg-[#3A85F7] text-[14px] font-medium text-[#FAFAFA]" onClick={() => {
                            onOpenChange(false);
                            setAddMessageCount("");
                            setAddMessageCountError(null);
                        }}
                        >
                            Close
                        </Button>
                        <Button className="mb-2 py-1 w-full bg-[#3A85F7] text-[14px] font-medium text-[#FAFAFA]" onClick={handleAddClick}>
                            Add
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateBalancePopUp;
